import React from 'react';
import { Typography } from 'antd';
import { MobileLayout } from 'common/components/Layouts/MobileLayout';

const { Title, Paragraph, Link } = Typography;

export const TosPage: React.FC = () => {
  return (
    <MobileLayout header="Terms & Conditions">
      <Paragraph className="fs">
        These Terms and Conditions shall apply to all orders of Minute Burger products (“Products”) of a customer through this{' '}
        <strong>MB Go!</strong> Website (“Site”). By placing an order for Products through this Site, you understand, agree with,
        and accept: (i) these Terms and Conditions and any corresponding changes thereto which we may implement from time to time;
        and (ii) our Privacy Policy in connection with how we process your personal information collected from this Site.
      </Paragraph>
      <Paragraph className="fs">
        For purposes of these Terms and Conditions, “Minute Burger”, “our” or “we” shall refer to Leslie Corporation and its
        subsidiaries, while “customer” or “you” shall refer to the customer who intends to purchase the Products from this Site.
      </Paragraph>
      <Paragraph className="fs">
        All materials/content found in our Online Services may not be copied, distributed, republished, uploaded, posted, or
        transmitted in any way, without our prior written consent EXCEPT you may download one copy materials and content on one
        computer for your personal, non-commercial, home use only. You may not delete or change any copyright, trademark, or other
        proprietary notices which may be incorporated in these Terms and Minute Burger Privacy Policy. Modification or use of the
        said materials and content as described in the Terms and Minute Burger Privacy Policy for any other purpose violates
        Minute Burger intellectual property rights.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        ACCOUNT CREATION
      </Title>
      <Paragraph className="fs">
        If you decide to place an order through this Site, you will be asked to register by creating an account which requires
        your personal information such as name, complete delivery address, telephone or mobile number, email address and a
        password. Creating an account allows you to automatically fill-up all the necessary delivery details in your next order.
        Inputting and confirming a password on the “Create an Account” or “Guest Information” page of the website, along with
        other information, allows you to make an account. You must keep this password confidential and must not disclose it to
        anyone. If you believe someone else knows your password, please change your password immediately.
      </Paragraph>
      <Paragraph className="fs">
        We reserve the right to suspend your registration if you violate any of these Terms and Conditions.
      </Paragraph>
      <Paragraph className="fs">
        When you choose to create an account by linking it with an external third party service or application, such as Facebook,
        this feature will not modify nor allow the access of the content of your Facebook account. However, if you use your
        Facebook account to create an account in this Site, the following shall apply:
      </Paragraph>
      <Paragraph className="fs">
        <ul>
          <li>Your Facebook account name shall be your Account name in the website;</li>
          <li>The e-mail address of your Facebook account shall be used as the e-mail address for your Account.</li>
        </ul>
      </Paragraph>
      <Paragraph className="fs">
        If another person used your account to order Products on your behalf, with or without your knowledge, such order shall be
        subject to these Terms and Conditions, and you agree that the order shall be considered your own and will be charged to
        you.
      </Paragraph>
      <Paragraph className="fs">
        Account creation enables participation in the Bitecoins Rewards Program. Program participation is subject to the terms
        outlined in the Bitecoins Rewards Program section.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        FINDING STORES NEAREST YOUR LOCATION
      </Title>
      <Paragraph className="fs">
        If you decide to use our Nearest Me feature, you will be asked by your browser to allow MB Go to use your current location
        to find stores. This information will only be used to find stores nearest your current location and will not be stored. If
        you would like to find stores nearest you on another time or date, you must select “Nearest Me” again. If your active
        location is currently moving such as in a moving vehicle or if you are walking, the Nearest Me feature may not be as
        accurate.
      </Paragraph>
      <Paragraph className="fs">
        The location feature is an approximate guide and uses your device’s GPS capabilities and connection to provide an
        approximate location. You must still refer to the address and map (provided at the checkout page) to confirm that the
        store you selected is indeed nearest your current location.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        SUBMISSION OF ORDER
      </Title>
      <Paragraph className="fs">
        Upon submission of your online order, you are authorizing us to process your online order and preparation of the Products
        you have specified on your order form. However, we reserve the right to refuse the processing of your order without any
        notification should we find any incorrect or incomplete details, or any previous spurious transactions with the given
        personal information.
      </Paragraph>
      <Paragraph className="fs">
        Also, non-response to SMS and calls from the store may result in late or non-delivery of the Products and should not be
        taken against us. Additional verification call or confirmation call may be required to proceed with your order.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        REGULAR ORDER
      </Title>
      <Paragraph className="fs">
        By submitting your order through this Site, you understand and agree that the processing of your order is subject to the
        following conditions:
      </Paragraph>
      <Paragraph className="fs">
        <ol>
          <li>
            There is a twenty (20) to thirty (30) minute preparation time for single receipt transactions amounting to{' '}
            <strong>P600 and below</strong>. The exact time of pickup shall be indicated at the order confirmation page which the
            customer will agree to once the order is placed. However, this preparation guarantee does not apply if there are more
            than 10 orders per transaction of the same product combinations. If we are unable to have your products prepared for
            pickup by the time that the order is due, you will be allowed to cancel your order due to waiting too long. You
            understand and accept, however, that any delay due to heavy traffic, inclement weather, unavoidable technical
            difficulties in the stores, or similar or conditions or circumstances, are beyond our control and should not at any
            time be taken against us. Pickup services may also not be available in cases of extreme weather, natural disasters,
            and unavoidable technical difficulties in the store/s in your area.
          </li>
          <li>
            For Orders amounting to <strong>P600</strong> and up you will receive a call from our store to verify your identity
            and your order details. Due to the volume of the Products ordered, we do not guarantee that orders can be prepared
            within the standard preparation time and the store will coordinate with you on the serving time.
          </li>
          <li>
            Orders above <strong>P1500</strong>, are considered bulk orders and will not be accepted by the Site. Instead,the Site
            will prompt you to contact the store directly to place your order.
          </li>
          <li>Excessive requests of items such as packaging, paper napkins, and the like are subject to store discretion.</li>
          <li>
            Any other special request outside the list of the Minute Burger product menu is strictly prohibited. Additional
            special request such as medicine, newspaper, cigarettes, grocery items and the likes will not be entertained.
          </li>
        </ol>
      </Paragraph>
      <Title level={2} className="fs-xxs">
        ADVANCE ORDER
      </Title>
      <Paragraph className="fs">
        If you wish to order in advance through this website, you may place your order within the calendar day.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        ORDER ACCEPTANCE & CONFIRMATION
      </Title>
      <Paragraph className="fs">
        The acceptance of orders for the Products made through the Site shall be at the entire discretion of Minute Burger. We
        reserve the right to decline to accept the order or deliver the Products without giving any reason.
      </Paragraph>
      <Paragraph className="fs">
        Our acceptance of an order occurs when the order status has been updated to show that the store is now preparing your
        order (“Order Confirmation”). The Order Confirmation is a record of our agreement to deliver the Products you ordered and
        your obligation to pay the price of the Products in full. The Order Summary serves as your Order Confirmation and will
        contain the following information:
      </Paragraph>
      <Paragraph className="fs">
        <ol>
          <li>Your pertinent order number;</li>
          <li>The date and time of your order;</li>
          <li>The total amount payable;</li>
          <li>The address of the store and name of the store where the order will be picked up;</li>
          <li>The Minute Burger store that has received and will process your order; and</li>
          <li>The contact number of the Minute Burger store that has received your order.</li>
        </ol>
      </Paragraph>
      <Title level={2} className="fs-xxs">
        CHANGES OF ORDER
      </Title>
      <Paragraph className="fs">
        Changes in your order can be made before a store accepts your order by cancelling it and re-ordering.
      </Paragraph>
      <Paragraph className="fs">
        After the store has accepted your order, cancellations will no longer be accepted as the order has already begun
        preparation and cooking.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        CANCELLATION OF ORDERS
      </Title>
      <Paragraph className="fs">
        Orders may be cancelled before a store accepts your order. Cancellation immediately after the time that the Order
        Confirmation was received will no longer be valid. You understand and agree that cancellation beyond this time will
        require you to pay the full amount of the order placed by you.
      </Paragraph>
      <Paragraph className="fs">
        We reserve the right to cancel an order of a customer in case the store has tried to call you over local phone or sent you
        messages via local SMS and the store is unable to reach you after 3 tries within 5 minutes.
      </Paragraph>
      <Paragraph className="fs">
        If payment is made via payment gateway and the cancellation of order was successful, a refund will be issued following the
        terms and conditions of the payment gateway.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        PRICES AND PAYMENT
      </Title>
      <Paragraph className="fs">
        Unless otherwise stated in writing, the Product prices quoted on this Site are inclusive of value-added taxes, any other
        applicable taxes and delivery charge. The Product prices on this Site are subject to change without prior notice.
      </Paragraph>
      <Paragraph className="fs">
        To check the price/s of the Product you want to order, please click the Checkout button to see the breakdown and total
        amount due.
      </Paragraph>
      <Paragraph className="fs">You can pay by any of the following methods, when available:</Paragraph>
      <Paragraph className="fs">
        <ul>
          <li>
            Cashless mode of payment through the website (through available e-wallets), subject to the condition that the partner
            payment integration may not be available 24 hours. Cashless payment through the website will involve a redirection to
            a third-party payment gateway. You acknowledge that Minute Burger will not be responsible for any information provided
            in the payment gateway.
          </li>
        </ul>
      </Paragraph>
      <Paragraph className="fs">
        If your order is placed using a credit card, such card should be valid on the date of pickup of your order.
      </Paragraph>
      <Paragraph className="fs">
        We reserve our right to refuse to prepare any order if for whatever reason we believe that payment will be refused at any
        stage.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        REFUND
      </Title>
      <Paragraph className="fs">
        Refunds for orders paid online will be issued through our 3rd Party Payment Processing Partner (Paymongo) and will be
        automatically processed by the system upon unsuccessful order completion (such as a Cancelled order).
      </Paragraph>
      <Paragraph className="fs">
        Should you believe that your refund was not properly credited to your original payment method, please contact us at{' '}
        <Link href="https://mbcustomerservice.zendesk.com/hc/en-us/requests/new">MB Go! Customer Care</Link> with your Order
        Number. We will be happy to assist you.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        ORDER AHEAD CONDITIONS
      </Title>
      <Paragraph className="fs">
        You agree to accept delivery of the Products at the agreed time and place of pickup, subject to the specific delivery
        conditions below:
      </Paragraph>
      <Title level={3} className="fs">
        Pickup Time
      </Title>
      <Paragraph className="fs">
        The arrival time in our pickup service guarantee will be based on the readiness of the product upon customer’s arrival at
        the front counter of the store. We shall exert reasonable efforts to meet the guaranteed preparation time, where
        applicable. You understand and accept, however, that any delay due to calamity, inclement weather or similar or analogous
        conditions or circumstance, are beyond our control and should not at any time be taken against us.
      </Paragraph>
      <Title level={3} className="fs">
        Product Availability
      </Title>
      <Paragraph className="fs">
        You understand and agree that Product/s are subject to availability at the time of ordering. If the Products you wish to
        order are not available, it will be reflected in the website that it is unavailable. If at the time of submitting your
        order the products have become unavailable, the store receiving your order may offer you a reasonable substitute Product
        or equivalent quality and price or we may advise you through phone call (local Philippines) or SMS for alternative
        Product/s. You understand that should you choose to order other Product/s, this may affect the purchase price.
      </Paragraph>
      <Paragraph className="fs">
        You also understand that if the store is unable to reach you by Phone Call or SMS to confirm your order at least 3 times
        within 5 minutes, the store reserves the right to assume the order will no longer push through and will cancel your
        order.{' '}
      </Paragraph>
      <Title level={3} className="fs">
        ID Validation
      </Title>
      <Paragraph className="fs">
        Upon pickup of your order, you will be requested to present a valid ID to our store crew for validation as well as your
        unique order number.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        PROMOTIONS (SPECIAL OFFERS)
      </Title>
      <Paragraph className="fs">
        From time to time, products may be subject to special offers. Any special offer shall be subject to these Terms and
        Conditions. In case of inconsistency between the special offer and these Terms and Conditions, the latter shall prevail.
        The Bitecoins Rewards Program is subject to these Terms and Conditions, with specific Program terms outlined in the
        dedicated Bitecoins Rewards Program section. We reserve the right to change the conditions and/or availability of special
        offers or withdraw them at our discretion. However, we will honor any order received before the withdrawal or changes on
        the special offers. All special offers are valid only within the promotional period, are subject to change and are not
        valid in conjunction with other offers, unless otherwise stated.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        BITECOINS REWARDS PROGRAM
      </Title>
      <Title level={3} className="fs">
        Program Overview
      </Title>
      <Paragraph className="fs">
        The Bitecoins Rewards Program (”Program”) is a loyalty program offered by Minute Burger to reward customers for their
        purchases. By participating in the Program, you agree to these terms and conditions.
      </Paragraph>
      <Title level={3} className="fs">
        Earning Bitecoins
      </Title>
      <Paragraph className="fs">
        <ul>
          <li>Customers earn Bitecoins for every purchase made through the MB Go! platform</li>
          <li>Bitecoins are calculated based on a conversion rate from Philippine Pesos (PHP)</li>
          <li>Any remaining amount from a purchase that does not convert to a full Bitecoin is forfeited</li>
          <li>Bitecoins are earned only after an order is successfully completed and picked up by the customer</li>
          <li>
            If you have purchased Product/s using a promotion that discounts a partial amount of the total value of the Product/s
            in your bag, you will earn Bitecoins equivalent only to the portion you have paid for qualifying products. The
            discounted portion of the total is not included in the computation of the Bitecoins.
          </li>
          <li>
            If you have purchased Product/s during a Double Bitecoins rewards event, you will receive double the amount of
            Bitecoins on the portion you have paid for on qualifying products.
          </li>
          <li>
            If you have earned Bitecoins through the Friend-code Referral Program, you will receive a predetermined amount of
            Bitecoins based on the program’s mechanics. Minute Burger reserves the right to change the amount received at any
            time. A friend-code must be used by a New User account to successfully complete an order. Bitecoins will not be
            rewarded in the event of a cancellation by the New User account or the Store before the order is completed.
          </li>
        </ul>
      </Paragraph>
      <Title level={3} className="fs">
        Bitecoins Expiry and Renewal
      </Title>
      <Paragraph className="fs">
        <ul>
          <li>Bitecoins have an expiry period as determined by Minute Burger</li>
          <li>
            The expiry clock for all Bitecoins in a customer’s wallet is reset when the customer makes a purchase or redeems a
            reward
          </li>
          <li>
            If a customer fails to make a purchase or redeem a reward within the expiry period, all Bitecoins in their wallet will
            expire
          </li>
        </ul>
      </Paragraph>
      <Title level={3} className="fs">
        Redemption and Usage
      </Title>
      <Paragraph className="fs">
        <ul>
          <li>Bitecoins can be redeemed for rewards as specified in the Program</li>
          <li>Bitecoins cannot be converted into cash</li>
          <li>
            Bitecoins and rewards obtained through the Program are not for sale and cannot be transferred or sold to other users
          </li>
        </ul>
      </Paragraph>
      <Title level={3} className="fs">
        Wallet Limits and Changes
      </Title>
      <Paragraph className="fs">
        <ul>
          <li>The Program has a maximum Bitecoins wallet limit</li>
          <li>Customers cannot earn additional Bitecoins if their wallet balance reaches the maximum limit</li>
          <li>Minute Burger reserves the right to change the wallet limit at any time without prior notice</li>
          <li>
            If customers have Bitecoins exceeding the new limit at the time of change, the excess Bitecoins will be forfeited.
          </li>
        </ul>
      </Paragraph>
      <Title level={3} className="fs">
        Program Modifications
      </Title>
      <Paragraph className="fs">
        <ul>
          <li>
            Minute Burger reserves the right to change the conversion rate of PHP to Bitecoins at any time without prior notice
          </li>
          <li>
            The Program terms, conditions, and benefits may be modified, suspended, or terminated at Minute Burger’s discretion
          </li>
          <li>Changes to the Program will be communicated through the MB Go! platform or via email</li>
        </ul>
      </Paragraph>
      <Title level={3} className="fs">
        Cancellations and Refunds
      </Title>
      <Paragraph className="fs">
        <ul>
          <li>
            If Bitecoins are used in an order that is subsequently cancelled for any reason, the Bitecoins will be refunded to the
            customer’s wallet
          </li>
          <li>Refunded Bitecoins will retain their original expiry date unless otherwise specified</li>
        </ul>
      </Paragraph>
      <Paragraph className="fs">
        The friend-code referral program was designed to encourage new users to join MB Go and its rewards program. We reserve our
        right to suspend user accounts that abuse the Bitecoins Rewards and Friend-code Referral Rewards system.{' '}
      </Paragraph>
      <Title level={2} className="fs-xxs">
        LIMITATIONS OF LIABILITY
      </Title>
      <Paragraph className="fs">
        We shall not be liable for any loss, expense, cost or damage arising out arising directly or indirectly out of or in
        connection with the delay beyond the estimated time or date of pickup, availability of product/s at any given time, force
        majeure, and any circumstances beyond our control, and over which we could not have avoided even with the exercise of
        reasonable care, or any indirect or unforeseeable loss suffered or incurred by customers or third parties. In any event,
        our liability for any given transaction shall not exceed the total price charged for the relevant Products.
      </Paragraph>
      <Paragraph className="fs">
        The Products ordered should be consumed within one (1) hour from the time that it was ready for pickup (refer to system
        status). We will not be liable for any event that may arise as a result/consequence of consuming the Products beyond the
        specified time.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        PRIVACY POLICY
      </Title>
      <Paragraph className="fs">
        Our Privacy Policy in connection with how we process your personal information collected from this Site, and any changes
        thereto, which we may implement from time to time, may be found in the Privacy Policy. You agree that with your acceptance
        of these Terms and Conditions, you have read, understood and accepted our Privacy Policy.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        UPDATING THESE TERMS AND CONDITIONS
      </Title>
      <Paragraph className="fs">
        Whenever necessary, we may, from time to time, update and/or revise these Terms and Conditions. We shall inform you of any
        update or revision by placing the date of the latest version on top of these Terms and Conditions.
      </Paragraph>
      <Title level={2} className="fs-xxs">
        CONTACT US
      </Title>
      <Paragraph className="fs pb-5">
        If you have any questions regarding these Terms and Conditions, please contact us through:{' '}
        <Link href="https://mbcustomerservice.zendesk.com/hc/en-us/requests/new">MB Go! Customer Care</Link>
      </Paragraph>
    </MobileLayout>
  );
};
